import { ViewController, Gradient, AuthorityCodeChangeEvent, TimeUpdateEvent, ClockView } from "@gaming/srvg-classes-core";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { CallToActionView } from "../../View/CallToActionView";

export const TEXT_PLACE_YOUR_BETS = 'Place your bets';
export const TEXT_BETSTOP = 'Betstop';

export const COUNTDOWN_START_BETSTOP = 1;
export const COUNTDOWN_START_PREMATCH = 2;

export class CallToActionViewController extends ViewController {
    callToActionView: CallToActionView;

    max: number;
    current: number;

    // animation settings
    start_animation: number; // countdown at which to start blinking
    blinkFadeTime: number;
    blinkInterval: any;

    gradient: Gradient;

    protected colorizeBackground: boolean;

    protected timeOfTimeout: number;

    protected countdownStartMode: number;

    constructor( options ) {
        options = options || { };
        options.name = options.name || 'calltoactionController';
        options.view = options.callToActionView || null;
        super( options );

        this.callToActionView = options.callToActionView || null;

        this.max = 0;
        this.current = 0;

        this.start_animation = options.start_animation || 10;
        this.blinkInterval = null;
        this.blinkFadeTime = 300;

        // color gradient for text color
        this.gradient = options.gradient || new Gradient( [
            jQuery.Color('#ff0000'), // red
            jQuery.Color('#ff7f00'), // orange
            jQuery.Color('#ffff00'), // yellow
            jQuery.Color('#00ff00')  // green
        ] );

        if( this.callToActionView && this.callToActionView.progressView ) {
            // Hack: use invisibility of progress view as indicator that the background color has to
            // be affected by the gradient.
            this.colorizeBackground = this.callToActionView.progressView.$domNode.is(':hidden');
        }
        else {
            this.colorizeBackground = false;
        }

        if( this.callToActionView ) {
            this.callToActionView.clockView.setDelegate( this );
        }

        this.timeOfTimeout = 0;

        this.countdownStartMode = options.countdownStartMode || COUNTDOWN_START_BETSTOP;
    }

    setCountdownStartMode( countdownStartMode: number ) {
        this.countdownStartMode = countdownStartMode;
    }

    private updateMax( now, timeOfNextBetstop ) {
        var currentChunk = app.timeline.currentChunkModel.chunk;
        if( ! currentChunk ) {
            return;
        }
        var timeOfLastBetstop = 0;
        if( currentChunk.betstop >= now ) {
            // current or future betstop
            timeOfLastBetstop = currentChunk.getPreviousBetstop();
        }
        else {
            // betstop in the past
            timeOfLastBetstop = currentChunk.betstop;
        }

        if( this.countdownStartMode == COUNTDOWN_START_BETSTOP ) {
            this.max = timeOfNextBetstop-timeOfLastBetstop;
            this.current = now-timeOfLastBetstop;
        }
        else if( this.countdownStartMode == COUNTDOWN_START_PREMATCH ) {
            this.max = timeOfNextBetstop-currentChunk.getPreMatchStartTime();
            this.current = now-currentChunk.getPreMatchStartTime();
        }
    }

    // ************************** Event handlers **************************

    handleChunkChangeEvent( event:ChunkChangeEvent, provider ) {
        if( !this.callToActionView ) {
            return;
        }
        var chunk = event.chunk;
        this.callToActionView.setChunk( chunk );
        this.callToActionView.chunkIndicatorView.setChunk( chunk );

        var now = app.server.getTime();
        //console.log("CallToActionViewController: ", chunk.betstop ," - " , now, " = ",  chunk.betstop-now);
        if( chunk.betstop > now ) {
            this.callToActionView.textView.setText( __(TEXT_PLACE_YOUR_BETS) );
            this.updateMax( now, chunk.betstop );
            this.callToActionView.setPosition( this.max - this.current );
        }
        else {
            this.callToActionView.textView.setText( __(TEXT_BETSTOP) );
            this.resetColor();
            this.stopBlinking();
            // clear (hide) the timer and progressbar
            this.callToActionView.clearCountdown();
        }

        if( this.callToActionView.programCodeNameView ) {
            this.callToActionView.programCodeNameView.setText( __('Program Code:') );
            this.callToActionView.programCodeValueView.setText( (chunk.competition as any).programCode );
        }
    }

    handleTimeoutEvent( event, provider ) {
        if( !this.callToActionView ) {
            return;
        }
        //console.log( 'handleTimeoutEvent' );
        if( provider == app.inactivityController ) {
            // idle timeout
            this.stopBlinking();
            this.callToActionView.disable();

            // hide all elements that would still be shown after other elements are already enabled
            this.callToActionView.progressView.hide();
            this.callToActionView.lockView.hide();
            this.callToActionView.textView.hide();
            this.callToActionView.chunkIndicatorView.hide();
        }
        else {
            // counter is finished
            this.timeOfTimeout = app.server.getTime();
            this.callToActionView.lockView.show();
            this.callToActionView.clockView.stop();

            // we also need to clear(hide) the clockView as lock and countdown would both be shown otherwise
            this.callToActionView.clockView.clear();

            this.callToActionView.textView.setText( __(TEXT_BETSTOP) );
        }
    }

    handleTimeUpdateEvent( event: TimeUpdateEvent, provider: ClockView ) {
        var currentChunk = app.timeline.currentChunkModel.chunk;
        //console.log( 'handleTimeUpdateEvent', event.time );
        var secondsLeft = event.time;
        if ( secondsLeft <= this.start_animation && ! this.isBlinking() ) {
            this.startBlinking();
        }
        if ( secondsLeft<=0 || secondsLeft > this.start_animation && this.isBlinking() ) {
            this.stopBlinking();
        }

        var progressOff = false;

        var now = app.server.getTime();

        if( this.callToActionView.chunk && currentChunk && this.callToActionView.chunk.isGreaterThan( currentChunk ) ) {
            if( currentChunk.betstop/*+srvg.timelinePhases.betstop.length*/ >= now ) {
                progressOff = true;
            }
            if( currentChunk.next && ! currentChunk.next.isEqualTo( this.callToActionView.chunk ) ) {
                if( currentChunk.betstop/*+srvg.timelinePhases.betstop.length*/ < now ) {
                    progressOff = true;
                }
            }
        }

        if( progressOff ) {
            this.max=secondsLeft;
            this.current=secondsLeft;
        }
        this.callToActionView.progressView.setPosition( 1-(secondsLeft/this.max) );

        this.colorize( secondsLeft/this.max );
    }

    handleAuthorityCodeChangeEvent(event: AuthorityCodeChangeEvent, provider){
        this.callToActionView.chunkIndicatorView.setAuthorityCode(event.data.authorityCode);
    }

    // ************************** Colorization functions **************************

    protected setColorForSubViews( color: string ) {
        var that = this;

        var views = [
            that.callToActionView.textView,
            that.callToActionView.clockView
        ];

        views.forEach( function( view )  {
            // for collapsed mode it is needed to recognize which mode is set.
            // if the progressbar is not visible the background color is colorized too.
            if (that.colorizeBackground){
                view.$domNode.find('.clock-min, .clock-hrs, .clock-sec').css('backgroundColor', color);
            }

            view.$domNode.css('color', color);

            var shadow = view.$domNode.css( 'text-shadow' );
            if( shadow && shadow != 'none' && typeof shadow === 'string' ) {
                // colorize glow
                view.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
            }
        } );
    }

    /**
     * Colorize all subviews using the given fraction of the gradient
     */
    protected colorize( fraction:number ) {
        //console.log( 'colorize()', fraction );

        var color = this.gradient.getInterpolatedColor( fraction );

        this.setColorForSubViews( color );
    }

    // start blinking at the end of the countdown
    startBlinking() {
        var that = this;
        var anim = function () {
            that.callToActionView.textView.$domNode.fadeOut(that.blinkFadeTime).fadeIn(that.blinkFadeTime);
            that.callToActionView.clockView.$domNode.fadeOut(that.blinkFadeTime).fadeIn(that.blinkFadeTime);
        };
        this.blinkInterval = setInterval(anim, 1000);
    }

    // animation stop
    stopBlinking() {
        if( this.blinkInterval ) {
            clearInterval(this.blinkInterval);
            var that = this;
            this.blinkInterval = null;
            that.callToActionView.textView.$domNode.stop(true, true).css('display', ''); // don't use show() because that sets display:block;
            that.callToActionView.clockView.$domNode.stop(true, true).css('display', ''); // don't use show() because that sets display:block;
            this.resetColor();
        }
    }

    // is the animation running?
    isBlinking() {
        return this.blinkInterval;
    }

    resetColor() {
        /*var shadow;
        var color = this.gradient.getInterpolatedColor(0);
        shadow = this.callToActionView.logoView.$domNode.css( 'text-shadow' );
        if( shadow && shadow != 'none' ) {
            this.callToActionView.logoView.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
        }
        shadow = this.callToActionView.textView.$domNode.css( 'text-shadow' );
        if( shadow && shadow != 'none' ) {
            this.callToActionView.textView.$domNode.css( 'text-shadow', shadow.replace( /rgb\([^\)]+\)/g, color ) );
        }*/
    }
}